<template>
  <div>
  <NoTopNavFooter/>
    <div id="login-background" style="background: #ECECEC;">
      <spinner :spinnerOn="loading"></spinner>
      <!-- v-bind:class="{ opaqueSpinner: isFromUserReg } -->
      <!--img src="../assets/img/png/bgi.jpg" class="splash"-->
	    <div v-if="accessDenied" class="clogindiv" style="text-align: center;color: rgb(217, 57, 52);font-size: 14px;padding: 20px 30px;margin-top: 90px;opacity: 0.95;">
        <!--img src="../assets/img/logo-cargill.gif" style="display: block;width: 120px;">
		    <div style="border-top: 1px solid #ddd;margin-bottom: 10px;"></div-->
        <div v-if="isMMApp">
          <div style="font-weight: bold; font-size: 48px;">400</div>
          <div class="bad-request-title">Bad Request</div>
        </div>
	      <div v-if="!isMMApp">
          <div style="border: 1px solid #ddd;border-radius: 3px;height: 45px;">
            <div style="display: inline-block;float: left;height: 100%;background: rgb(217,57,52);color: #fff;padding: 7px 3px 10px 7px;
              border-top-left-radius: 3px;border-bottom-left-radius: 3px;">
              <i class="fa fa-exclamation-circle" style="margin-right: 5px; padding-top: 7px; font-size: 16px;"></i>
            </div>
            <div class="error-title">Access denied</div>
          </div>
          <div style="margin:10px;font-size:18px;font-weight:bold;"> {{customErrorMsg}} </div>
          <div style="margin:10px;font-size:18px;color:#000" v-if="customContact.length > 0"> Please <a :href="`mailto:${customContact}`">contact us</a> for further Assistance / Support. </div>
        </div>
      </div>
	  </div>
	</div>
</template>
<script>
  import NoTopNavFooter from "@/components/widgets/NoTopNavFooter"
  // import authapi from '@/helpers/auth-api'
  import Spinner from '@/components/Spinner'
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import customError from "../helpers/custom-error";
  export default {
    name: 'Error',
    components: {
      NoTopNavFooter,
      Spinner
    },
    data() {
      return {
        stateToken: '',
        isMobile: "ontouchstart" in document.documentElement, // /Mobi/.test(window.navigator.userAgent)
        loading: false,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        user_lang: {},
        accessDenied: true,
        isMMApp: false,
        location: window.location.href,
        customErrorMsg: '',
        customContact: ''
      }
    },
    props: {
    },
    computed: {
    },
    created() {
      var self = this
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese lang
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
      $(document).on('click', '#okta-signin-submit, #cargillLogin', function() {
        self.accessDenied = false
      })
      if (self.location.indexOf('app=milkMoovement') > -1) {
        self.isMMApp = true;
      }
      self.getAppDetails();
    },
    mounted() {
      // var fromLogin = this.getParameterByName('fromLogin', document.location.href)
    },
    methods: {
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      getAppDetails() {
        let self = this
        let appName = self.getParameterByName('app', self.location)
        let appDetails = customError.getCustomErrorMsg(appName);
        self.customErrorMsg = appDetails.msg
        self.customContact = appDetails.contact
      },
      getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
    }
  }
</script>
<style scoped>
html, body {
  background-color: #FFF;
  margin: 0px;
  height: auto;
}
#login-background {
  background-color: #FFF;
  padding: 0;
  margin:0;
  /*background: url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat !important;*/
}
.login-form, .forgotPasswordSection{max-width: 400px;    margin: auto;}
.form-control{margin: 10px 0px;}
.non-anchor-link{cursor:pointer;user-select:none;display: inline-block;margin-top: 3px;}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.logo{margin:20px;text-align: center;}
.logo img {max-width: 120px;
	    width: 120px;}
.instruction {font-size:13px;}
button {text-transform: none !important;}
button:focus {color: #ffffff !important;}
body{background: #FFF; /* url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat */
    background-size: cover;}
#app, #login-background, html{background:transparent}
.custom-login{padding:20px;max-width: 440px;
    margin: auto;
    background: #ffffff97;border-radius: 2px;}
.mailsent, .entersmssent{text-align: center;
    font-weight: bold;}
.emailsenttext{font-size: 14px;
    margin-bottom: 30px;text-align: center;}
.btn{cursor:pointer}
.resend-code{cursor: pointer}
.resend-code:focus{color:#464a4c !important}
.disabled {pointer-events:none;opacity:0.5}
.alternateReset {font-size: 14px;text-decoration:none;text-align: center; cursor:pointer;margin-bottom:15px;}
#login-background{
    width: calc(100vw);
    box-sizing: border-box;
    height: calc(100vh);
    background-size: cover !important;
    /* margin-top: -64px; */
    padding-top: 60px;
}
.alternateReset:hover {text-decoration:underline;}
.errorList{color:#d00000; background: #ffc6d195;
    padding: 5px;}
.opaqueSpinner {background: white !important;}
.pwderror{display: block;
    background: #c5c5c5;
    padding-left: 10px;
    color: #ffffff;
    border-bottom: 1px solid #eaeaea;
    max-width: 400px;}
.splash{
position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
	object-fit: cover;}
.clogindiv{
     max-width: 500px;
	 width: initial !important;
    background-color: #fff !important;
    margin: auto;
    padding: 20px 30px;
    z-index: 999999999;
    margin-top: -7px;
    border-radius: 0;
}
#cargillLogin{
    white-space: normal;
    background-color: var(--theme-primary);
    font-weight: normal;
    width: 100%;
    border-radius: 1px;
    font-size: 13px;
    box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0, rgba(255, 255, 255, 0.1) 0 1px 0 0 inset;
	cursor:pointer;
}
.error-title {
  display: inline-block;
  color: #000000;
  float: left;
  padding: 8px;
  font-size: 16px;
  font-weight: 600;
}
.bad-request-title {
  color: #000000;
  padding: 8px;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Error.vue?2c9fcef4